import { createActions, createReducer, resettableReducer } from 'reduxsauce';
import {
  BASE_INITIAL_STATE,
  DETAILS_SET_INITIAL_STATE,
  FAVOURITE_ACTIONS_SET,
  BASE_DETAILS_ACTIONS_SET,
  getRequestDetailsHandler,
  getSuccessDetailsHandler,
  getFailureDetailsHandler,
  toggleFavouriteInDetail,
} from '../../../store/structures';
import { types as loginTypes } from '../../auth/login';

export const COUPON_DETAIL_INITIAL_STATE = BASE_INITIAL_STATE;

export const { Types: types, Creators: actions } = createActions(
  {
    getDetail: ['id'],
    removeCoupon: ['id'],
    ...BASE_DETAILS_ACTIONS_SET,
    ...FAVOURITE_ACTIONS_SET,
  },
  {
    prefix: 'cb/coupons/detail/',
  },
);

const HANDLERS = {
  [types.REQUEST]: getRequestDetailsHandler(COUPON_DETAIL_INITIAL_STATE),
  [types.SUCCESS]: getSuccessDetailsHandler(),
  [types.FAILURE]: getFailureDetailsHandler(),
  [types.TOGGLE_FAVOURITE]: toggleFavouriteInDetail,
};

export default resettableReducer(loginTypes.LOGOUT)(
  createReducer(DETAILS_SET_INITIAL_STATE, HANDLERS),
);
